<template>
    <div class="title1">
        <P>主设备规模</P>
        <div class="title-info">Main equipment scale</div>
    </div>
    <ul class="box">
        <li v-for="(item,i) in list" :key="i">
            <div class="list-box">{{item.num}}<span>{{item.unit}}</span></div>
            <p>{{item.info}}</p>
        </li>

    </ul>
</template>

<script>
    import {reactive} from 'vue';

    export default {
        name: "mainES",
        setup(){
            var list = reactive([
                {
                    num:248,
                    unit:'台',
                    info:'变压器220KV'
                },{
                    num:343,
                    unit:'台',
                    info:'开关柜35KV'
                },{
                    num:545,
                    unit:'台',
                    info:'接地变110V'
                },{
                    num:767,
                    unit:'台',
                    info:'变压器220KV'
                },{
                    num:356,
                    unit:'台',
                    info:'GIS   220V间隔'
                },{
                    num:545,
                    unit:'台',
                    info:'GIS   110V间隔'
                }
            ]);
            return{
                list,
            }
        }
    }
</script>

<style scoped lang="less">
    @import "./../../assets/canshu";
    .title1{
        background: url("./../../assets/title.png") no-repeat;
        background-size: 100% 100%;
        width: 232px;
        height: 4.17vh;/*no*/
        position: relative;
        p{
            font-size: 24px;
            color: #fff;
            font-family: cn;
            position: absolute;
            left: 5%;
        }
        .title-info{
            width: 202px;
            height: 1.66vh;
            background: #1a8379;
            position: absolute;
            bottom: -30%;
            left: 5%;
            display: flex;
            align-items: center;
            padding-left: 5px;
            box-sizing: border-box;
            font-size: 12px;
            color: #fff;
            font-family: cn;
        }
    }
    .box{
        width: 363px;
        height: 21.50vh;
        background: url("./../../assets/mainES-bg.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 26vh*@vh;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        box-sizing: border-box;
        color: #fff;
        font-family: cn;
        overflow: hidden;
        li{
            margin-left: 13px;
            .list-box{
                font-size: 20px;
                color: #fff;
                font-family: cn;
                background: url("./../../assets/mainES-circle.png") no-repeat;
                background-size: 100% 100%;
                width: 78px;/*no*/
                height: 77px;/*no*/
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                    font-size: 10px;
                    margin-left: 5px;
                }
            }
            p{
                font-size: 10px;
                text-align: center;
            }
        }
    }
</style>